module.exports = __webpack_public_path__ + "static/media/image-slash.ab166053.svg";